import { render } from "./MemberImportPage.vue?vue&type=template&id=2724f98e&scoped=true"
import script from "./MemberImportPage.vue?vue&type=script&lang=js"
export * from "./MemberImportPage.vue?vue&type=script&lang=js"

import "./MemberImportPage.vue?vue&type=style&index=0&id=2724f98e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2724f98e"]])

export default __exports__